module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAASRJREFUeAHt2A0KwjAMQGF3C3da7+HF9DYzGS0MsezHtUmzVygVEdv3IWK93RgIIIAAAggggAACCCCAAAIIIIAAAu0Epmm662y3o6OdUvxLVp3XQljEy8N5XAdBcvVjr8HfIz6CFJfiM0ZchA3xcRF2xMdDOBAfB2FD/FNeo7M0+v1OkKK1LzwNH9KMhbA1Pv8uC4WwNz4UwtH4EAj/xneNcFZ8lwhnx3eFUCu+C4Ta8a4RWsW7RGgd7wrBKt4FgnW8KYKXeDOEFYD5VpcP12qVM+lNsnSLPP8anRDesi6HSXxGloP8QtAz1vmbXd9YZkYwjS8g1ItfbDgKwkPmkJ+zXvUs6Uyj9VnYHwEEEEAAAQQQQAABBBBAAAEEEEAAAQR8C3wAbhQWY8twndQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navigation-up@2x.png
// module id = Xhq1
// module chunks = 1